module.exports = __webpack_public_path__ + "static/media/frog(23).b3b3686a.PNG";